<div class="top">
    <div class="header">
        <h1 align="center">Blog</h1>
    </div>
    <div class="vc_empty_space" style="height: 30px;"><span class="vc_empty_space_inner"></span>
    </div>
    <div class="header1">
        <div class="qodef-post-link-holder">
            <div class="qodef-post-link-holder-inner">
                <h2 style="margin-bottom: 20px;">
                    Personal Shopper from India
                </h2>
            </div>
        </div>
        <div class="row col-xs-12 col-sm-12 col-md-12">
            <div class="col-xs-12 col-sm-5 col-md-5">
                <figure class="wp-block-image size-large"><img
                        src="https://yourdesicart.com/wp-content/uploads/2020/09/Pinterest-2-683x1024.png" alt=""
                        class="wp-image-6603"
                        srcset="http://yourdesicart.com/wp-content/uploads/2020/09/Pinterest-2-683x1024.png 683w, http://yourdesicart.com/wp-content/uploads/2020/09/Pinterest-2-200x300.png 200w, http://yourdesicart.com/wp-content/uploads/2020/09/Pinterest-2-100x150.png 100w, http://yourdesicart.com/wp-content/uploads/2020/09/Pinterest-2-768x1152.png 768w, http://yourdesicart.com/wp-content/uploads/2020/09/Pinterest-2.png 1000w"
                        style="width:90%;height:70%;margin-top:15px;"></figure>
            </div>
            <div class="col-xs-12 col-sm-7 col-md-7">
                <h2>Shopping and International Shipping from India Made Easy through
                    yourDesiCart.com</h2>
                <p><strong>Ever wanted to get Chole Masala from Sitaram Diwan Chand store in
                        Paharganj Delhi, Kanjeevaram saree from Kanchipuram Tamilnadu,
                        Pattachitra sarees handpainted from Orissa, Harmonium Musical Instrument
                        from Kolkata India? </strong><br><br>Would you like to be able to get
                    these items delivered worldwide with utmost care and personal shopping
                    preferences?<br><br><strong>yourDesiCart Personal Shopper can shop from
                        anywhere in India and deliver to your doorstep worldwide.</strong> Our
                    Personal Shoppers are spread all over India to serve all your shopping needs
                    from India.</p>
                <h2>How to get yourDesiCart at your doorstep worldwide?</h2>
                <ol>
                    <li>Signup – to get yourDesiCart Locker Address to store your purchases in
                        India – https://yourdesicart.com/order-now</li>
                    <li>Shop – Personal Shopper will shop from anywhere in India &amp; ship to
                        your Locker – http://yourdesicart.com/pricing-services/</li>
                    <li>Ship – We will isnpect items, send pictures, consolidate all your
                        purchases into one single package &amp; ship it to your doorstep
                        worldwide</li>
                </ol>
                <p>Follow on Facebook – https://www.facebook.com/yourDesiCart/<br>Whatsapp –
                    https://api.whatsapp.com/send?phone=918328579397</p>
                <p><br><br></p>
            </div>
        </div>
    </div>
    <footer>
        <div class="row col-xs-12 col-sm-12 col-md-12" id="footer">
            <div class="col-xs-12 col-sm-4">
                <div id="cvvv">
                    <h4 class="title">yourDesiCart</h4>
                    <div class="textwidget">
                        <div class="vc_empty_space" style="height: 12px"><span class="vc_empty_space_inner"></span>
                        </div>


                        <p>84 High street, Kondapur Hyderabad 500084</p>
                        <p>Email: yourDesiCart@gmail.com</p>
                        <p>Phone: +91 8328579397</p>
                        <div class="vc_empty_space" style="height: 32px"><span class="vc_empty_space_inner"></span>
                        </div>
                        <span style="margin: 0px 5px 0px 0px">
                            <a itemprop="url" class="" href="https://www.facebook.com/yourDesiCart" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-facebook qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://twitter.com/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-twitter qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.linkedin.com/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-linkedin qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.instagram.com/yourDesiCart" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-instagram qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://in.pinterest.com/yourDesiCart/" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-pinterest qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                        <span style="margin: 0px 5px 0px 5px">
                            <a itemprop="url" class="" href="https://www.youtube.com" target="_blank"
                                rel="noopener noreferrer">
                                <span class="flip-icon-holder">
                                    <span class="icon-normal"><i
                                            class="qodef-icon-font-awesome fa fa-youtube-play qodef-icon-element"
                                            style="color:#ffff;font-size:22px"
                                            onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                            onMouseOut="this.style.color='#ffffff'"></i></span>
                                </span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <!-- <div class="vertical-line" style="height: 200px;width:0.1px; color: silver"></div>
                        <div class="col-xs-12 col-sm-3">
                            <div class="qodef-column" style="margin-top: 40px;margin-left: 15px;">
            
                                <div class="textwidget custom-html-widget"><a href="terms-of-use">Terms of
                                        Use</a></div>
            
                                <div id="custom_html-3" class="widget_text widget qodef-footer-column-2 widget_custom_html">
                                    <div class="textwidget custom-html-widget"><a href="prohibited-items">Prohibited
                                            Items</a></div>
                                </div>
                            </div>
                        </div> -->
            <div class="vertical-line" style="height: 200px;"></div>
            <div class="col-xs-12 col-sm-4">

                <div id="cvvv">
                    <h4 class="title" style="margin-left: 15px;">Quick Links</h4>
                    <ul>
                        <li>
                            <a [routerLink]="[]" (click)="personal()">Personal
                                Shopper from India</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="onamshopping()">Onam
                                Shopping from India</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="tosis()">To Sis, With
                                Love</a>
                        </li>
                        <li>
                            <a [routerLink]="[]" (click)="provibited()">Prohibited
                                Items</a>
                        </li>


                        <li>
                            <a [routerLink]="[]" (click)="terms()">Terms of
                                Use</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="vertical-line" style="height: 200px;"></div>
            <div class="col-xs-12 col-sm-3">
                <div id="cvvv">
                    <h4 class="title" style="margin-left: 15px;">ContactUs</h4>
                    <ul>
                        <li>
                            <a [routerLink]="[]" (click)="contactUs()">ContactUs</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</div>